<template>
  <Bar
    :chart-options="chartOptions"
    :chart-data="chartData"
    :chart-id="chartId"
    :dataset-id-key="datasetIdKey"
    :plugins="plugins"
    :css-classes="cssClasses"
  />
</template>

<script>
import { Bar } from "vue-chartjs";
import {
  Chart as ChartJS,
  Title,
  Tooltip,
  Legend,
  BarElement,
  CategoryScale,
  LinearScale,
} from "chart.js";

ChartJS.register(
  Title,
  Tooltip,
  Legend,
  BarElement,
  CategoryScale,
  LinearScale
);

export default {
  name: "BarChart",
  components: { Bar },
  props: {
    chartId: {
      type: String,
      default: "bar-chart",
    },
    datasetIdKey: {
      type: String,
      default: "label",
    },
    width: {
      type: Number,
      default: 400,
    },
    height: {
      type: Number,
      default: 400,
    },
    cssClasses: {
      default: "",
      type: String,
    },
    plugins: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      dataChart: null,
      loaded: false,
      chartData: {
        labels: this.$store.state.latestRemittance?.map(
          (el) => el?.date.split(" ")[0]
        ),

        datasets: [
          {
            radius: 0,
            label: "Latest Remittance",
            borderWidth: 1,
            backgroundColor: (ctx) => {
              const canvas = ctx.chart.ctx;
              const gradient = canvas.canvas
                .getContext("2d")
                .createLinearGradient(0, 0, 0, 450);

              gradient.addColorStop(0, "#8DC63F");
              gradient.addColorStop(1, "#8DC63F");

              return gradient;
            },
            borderColor: "#8DC63F",
            pointBackgroundColor: "rgba(0,0,0,0)",
            pointBorderColor: "rgba(0,0,0,0)",
            pointHoverBorderColor: "#8DC63F",
            tension: 20,
            data: this.$store.state.latestRemittance?.map((el) =>
              el?.amount.replace(/,/g, "")
            ),
          },
        ],
      },
      chartOptions: {
        responsive: true,
        maintainAspectRatio: false,
        legend: {
          display: false,
        },
      },
    };
  },
};
</script>
